/** 
 * @type {MasterAccountsFilter} 
 */ 
 const filter = { 
with: null, 
orderBy: null, 
ids: null, 
country_ids: null, 
} 
 /** 
 * @returns {MasterAccountsFilter} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(filter)); 
 } 



// WEBPACK FOOTER //
// ./resources/js/filters/MasterAccountsFilter.js